module.exports = __webpack_public_path__ + "img/csueb.fullname.long.KO.4947fc75.svg";